// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1HqPt","content":"LayoutSettings_content__g49Bv"};